(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observed = new WeakSet();

  const editorialSelectors = {
    story: [
      ['.our-story__intro-copy', 'copy'],
      ['.our-story__media--hero', 'media'],
      ['.our-story__chapter-copy', 'copy'],
      ['.our-story__media--personal', 'media'],
      ['.our-story__collections-copy', 'copy'],
      ['.our-story__media--collection', 'media']
    ],
    'made-in-italy': [
      ['.made-italy__intro-copy', 'copy'],
      ['.made-italy__media--hero', 'media'],
      ['.made-italy__chapter-copy', 'copy'],
      ['.made-italy__media--maker-wide', 'media'],
      ['.made-italy__media--maker-detail', 'media', 120],
      ['.made-italy__materials-intro', 'copy'],
      ['.made-italy__material--merino .made-italy__material-copy', 'copy'],
      ['.made-italy__media--merino-main', 'media', 100],
      ['.made-italy__media--cotton', 'media'],
      ['.made-italy__material--cotton .made-italy__material-copy', 'copy', 100]
    ],
    care: [
      ['.care-editorial__intro-copy', 'copy'],
      ['.care-editorial__media--hero', 'media'],
      ['.care-editorial__merino .care-editorial__chapter-copy', 'copy'],
      ['.care-editorial__merino .care-editorial__tabs', 'copy', 90],
      ['.care-editorial__merino .care-editorial__accordions', 'copy', 90],
      ['.care-editorial__cotton-copy', 'copy'],
      ['.care-editorial__cotton .care-editorial__tabs', 'copy', 90],
      ['.care-editorial__cotton .care-editorial__accordions', 'copy', 90]
    ],
    'delivery-returns': [
      ['.service-editorial__intro', 'copy'],
      ['.service-editorial__chapter-intro', 'copy'],
      ['.service-editorial__details > div', 'copy', 70]
    ],
    privacy: [
      ['.privacy-editorial__intro', 'copy'],
      ['.privacy-editorial__policy', 'copy'],
      ['.privacy-editorial__copyright', 'copy']
    ]
  };

  let observer;

  const revealImmediately = (element) => element.classList.add('is-visible');

  const observe = (element, type = 'copy', delay = 0) => {
    if (!element || observed.has(element)) return;

    observed.add(element);
    element.dataset.rilabelReveal = type;
    if (delay) element.style.setProperty('--rilabel-reveal-delay', `${delay}ms`);

    if (reducedMotion.matches || !observer) {
      revealImmediately(element);
      return;
    }

    observer.observe(element);
  };

  const decorateHomepage = (root) => {
    const sections = Array.from(root.querySelectorAll(':scope > .shopify-section:not(.shopify-section-group-footer-group)'));

    sections.forEach((section, index) => {
      if (index === 0) return;

      const collageItems = section.querySelectorAll('.rilabel-editorial-collage__item');
      if (collageItems.length) {
        collageItems.forEach((item, itemIndex) => observe(item, 'media', itemIndex * 85));
        return;
      }

      const video = section.querySelector('.rilabel-editorial-video__frame');
      if (video) {
        observe(video, 'media');
        return;
      }

      observe(section, section.querySelector('img, video') ? 'media' : 'copy');
    });
  };

  const decorateEditorialPage = (root, page) => {
    (editorialSelectors[page] || []).forEach(([selector, type, delay]) => {
      root.querySelectorAll(selector).forEach((element) => observe(element, type, delay));
    });
  };

  const initialise = (root = document) => {
    const pageRoot = root.matches?.('[data-rilabel-motion-page]')
      ? root
      : root.querySelector?.('[data-rilabel-motion-page]') || document.querySelector('[data-rilabel-motion-page]');

    if (!pageRoot) return;

    const page = pageRoot.dataset.rilabelMotionPage;
    if (page === 'home') decorateHomepage(pageRoot);
    else decorateEditorialPage(pageRoot, page);
  };

  if (!reducedMotion.matches && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('rilabel-motion-ready');
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        revealImmediately(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.08
    });
  }

  initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
